import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { COPY } from '../copy';
import { currentNavItem } from '../router/currentNavItem';
import { NAV_ITEMS } from '../router/navItems';

/** CNPWKS-0011 P4: the current item's icon sits on the brand's `selected` layer. */
const PILL_CLASS = 'cnpwks-nav-pill';

export function BottomNav() {
  const { pathname } = useLocation();
  const current = currentNavItem(pathname);

  return (
    <Paper component="nav" aria-label={COPY.navLabel} square elevation={3}>
      <BottomNavigation showLabels value={current?.path ?? false}>
        {NAV_ITEMS.map(({ path, label, Icon }) => (
          <BottomNavigationAction
            key={path}
            value={path}
            label={label}
            icon={
              <Box
                component="span"
                className={PILL_CLASS}
                sx={{ display: 'inline-flex', px: 2, py: 0.25, borderRadius: 2 }}
              >
                <Icon />
              </Box>
            }
            component={RouterLink}
            to={path}
            nativeButton={false}
            aria-current={current?.path === path ? 'page' : undefined}
            sx={{
              [`&.Mui-selected .${PILL_CLASS}`]: { bgcolor: 'action.selected' },
              '&.Mui-selected .MuiBottomNavigationAction-label': { fontWeight: 600 },
            }}
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
}
